import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { SharedDataService } from '../../../../../services/shared-data.service';
import { EnvironmentService } from '../../../../../services/environment.service';

@Component({
    selector: 'app-api-swagger-ui',
    templateUrl: './api-swagger-ui.component.html',
    styleUrls: ['./api-swagger-ui.component.css'],
    standalone: false
})
export class ApiSwaggerUiComponent implements OnInit {
  url = 'https://api-local.fincura.com:8001/v1/swagger-ui/';
  urlSafe: SafeResourceUrl;

  constructor(public sanitizer: DomSanitizer,
    private _sharedDataService: SharedDataService,
    private _environmentService: EnvironmentService, ) { }

  ngOnInit() {
    const open_api = this._environmentService.getOpenApiSchemaUrl();
    const url = `/assets/html/swagger-ui.html?openapi=${encodeURIComponent(open_api)}`
    this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this._sharedDataService.pageHeaderTitle$.next('API - Swagger UI');
  }

}
